import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "@src/store/rootState";
/**
 * Checks if the experience has custom targeting configured.
 * Returns true if any of the following are set:
 * - Audience filters (custom audience rules)
 * - Page targeting expressions
 * - Currency targeting (exclude currency or specific currency set)
 */
export const hasCustomTargeting = createSelector(
  (state: RootState) => state.audience.audience,
  (state: RootState) => state.pageTargeting.pageTargeting,
  (audience, pageTargeting) => {
    const hasAudienceFilters = (audience?.filters?.length ?? 0) > 0;
    const hasPageTargeting =
      pageTargeting.length > 0 && pageTargeting[0]?.expression != null;
    const hasCurrencyTargeting =
      audience?.excludeCurrency?.currency != null ||
      audience?.excludeCurrency?.exclude === true;

    return hasAudienceFilters || hasPageTargeting || hasCurrencyTargeting;
  }
);
